export enum ConfigKeys {
  PORT = 'PORT',
  UPDATER_MS_PORT = 'UPDATER_MS_PORT',
  UPDATER_MS_HOST = 'UPDATER_MS_HOST',
  BASE_URL = 'BASE_URL',
  SMG_URL = 'SMG_URL',
  WOD_URL = 'WOD_URL',
  ADFS_ENDPOINT = 'ADFS_ENDPOINT',
  ADFS_CLIENT_ID = 'ADFS_CLIENT_ID',
  MAIL_HOST = 'MAIL_HOST',
  MAIL_USER = 'MAIL_USER',
  MAIL_PASSWORD = 'MAIL_PASSWORD',
  MG_USERNAME = 'MG_USERNAME',
  MG_PASSWORD = 'MG_PASSWORD',
  JWT_SECRET = 'JWT_SECRET',
  DB_HOST = 'DB_HOST',
  DB_PORT = 'DB_PORT',
  DB_DIALECT = 'DB_DIALECT',
  DB_USERNAME = 'DB_USERNAME',
  DB_PASSWORD = 'DB_PASSWORD',
  DB_NAME = 'DB_NAME',
  ENVIRONMENT = 'ENVIRONMENT',
  DEVELOPERS_EMAILS = 'DEVELOPERS_EMAILS',
  SUPPORT_USERS_EMAILS = 'SUPPORT_USERS_EMAILS',
  ORIGIN = 'ORIGIN',
  OAUTH_CLIENT_ID = 'OAUTH_CLIENT_ID',
  OAUTH_CLIENT_SECRET = 'OAUTH_CLIENT_SECRET',
  OAUTH_ACCESS_TOKEN_URI = 'OAUTH_ACCESS_TOKEN_URI',
  AGREEMENT_LINK = 'AGREEMENT_LINK',
  TEST_SECRET = 'TEST_SECRET',
  NOTIFICATION_CC_EMAIL = 'NOTIFICATION_CC_EMAIL',
  MASTER_PASSWORD = 'MASTER_PASSWORD',
  NODE_APP_INSTANCE = 'NODE_APP_INSTANCE',
  ROLLBAR_TOKEN = 'ROLLBAR_TOKEN',
  AUTH0_URL = 'AUTH0_URL',
  AUTH0_AUDIENCE = 'AUTH0_AUDIENCE',
  AUTH0_ISSUERS = 'AUTH0_ISSUERS',
  WOD_LINK = 'WOD_LINK',
  SMG_LINK = 'SMG_LINK',
  PERSONNEL_DEPARTMENT_POLAND_MAIL = 'PERSONNEL_DEPARTMENT_POLAND_MAIL',
  WSP_LINK = 'WSP_LINK',
  STLAB_LINK = 'STLAB_LINK',
  STLAB_LINK_UZ = 'STLAB_LINK_UZ',
  ITECHART_MAIN_RESOURCE_LINK = 'ITECHART_MAIN_RESOURCE_LINK',
  WIKI_MAIN_LINK = 'WIKI_MAIN_LINK',
  HUB_LINK = 'HUB_LINK',
  SLACK_LINK = 'SLACK_LINK',
  DEVELOPER_CONTACT_MAIL = 'DEVELOPER_CONTACT_MAIL',
  POLISH_COURSES_CONTACT_MAIL = 'POLISH_COURSES_CONTACT_MAIL',
  SMG_GUIDE_LINK = 'SMG_GUIDE_LINK',
  ERAMBA_POLICY_LINK = 'ERAMBA_POLICY_LINK',
  ERAMBA_AWARENESS_PORTAL_LINK = 'ERAMBA_AWARENESS_PORTAL_LINK',
  EMAIL_SIGNATURE_CREATE_INSTRUCTION = 'EMAIL_SIGNATURE_CREATE_INSTRUCTION',
  GM_POLAND_MAIL = 'GM_POLAND_MAIL',
  VENTION_MAIN_RESOURCE_LINK = 'VENTION_MAIN_RESOURCE_LINK',
  TG_CHAT_UZ = 'TG_CHAT_UZ',
  MS_TEAMS_CHAT_PL = 'MS_TEAMS_CHAT_PL',
  TG_CHAT_KZ = 'TG_CHAT_KZ',
}
